import React from 'react'

const CostSavingsIcon = () => {
    return (
        <>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width={60}
                height={60}
                x={0}
                y={0}
                viewBox="0 0 425 425.228"
                style={{ enableBackground: "new 0 0 512 512" }}
                xmlSpace="preserve"
                className=""
            >
                <g>
                    <path
                        fill="#00acea"
                        d="m365.563 192.145-14.848-1.57c-.512 0-1.055-.509-1.563-1.009-10.66-21.32-26.41-40.101-46.71-55.832a1.869 1.869 0 0 1-.524-1.52l2.535-23.347c2.031-18.27 2.54-24.86 2.031-27.91-.511-4.57-4.062-7.61-9.64-7.61-7.922-.273-21.516 2.618-33.301 6.528l-.043.012a96.664 96.664 0 0 1 1.883 19.058L73.324 126.367c-21.832 14.168-39.91 32.57-52.57 53.547l-7.27 13.711c-7.109 14.723-12.37 30.96-13.37 47.2v7.1c0 29.942 10.32 58.872 29.609 83.74.5.51.586 1.01.086 2.03-16.75 21.82-16.2 52.055 2.574 71.856 11.168 11.672 26.43 19.066 43.691 19.066h2.031c16.239 0 31.47-5.875 42.63-16.535l12.69-12.074c.41-.371.97-.535 1.52-.445a203.017 203.017 0 0 0 80.188 2.554 1.884 1.884 0 0 1 1.52.528l9.64 9.144c23.352 21.82 59.89 23.344 84.25 3.555 19.777-16.285 25.676-44.078 14.21-66.989-.51-.511 0-1.02 0-1.53a150.113 150.113 0 0 0 24.36-36.028c.512-.512 1.012-1.012 1.52-1.012l14.93-1.57c16.171-1.684 28.48-15.281 28.55-31.54v-49c-.074-16.253-12.383-29.847-28.55-31.53zm0 0"
                        opacity={1}
                        data-original="#00acea"
                        className=""
                    />
                    <path
                        fill="#ffe780"
                        d="M265.504 79.89a96.66 96.66 0 0 1 1.879 19.06c0 34.87-18.008 64.71-44.738 83.07H114.473C68.645 152.164 55.69 90.809 85.547 44.98A99.03 99.03 0 0 1 168.445 0c47.72 0 88.07 34.617 97.059 79.89zm0 0"
                        opacity={1}
                        data-original="#fedb41"
                        className=""
                    />
                    <path
                        fill="#083863"
                        d="M248.195 192.02H88.684c-5.524 0-10-4.477-10-10 0-5.524 4.476-10 10-10h159.511c5.524 0 10 4.476 10 10 0 5.523-4.476 10-10 10zm0 0"
                        opacity={1}
                        data-original="#083863"
                        className=""
                    />
                    <path
                        fill="#00acea"
                        d="M197.184 64.617c5.523 0 10-4.476 10-10 0-5.523-4.477-10-10-10h-58.141c-5.523 0-10 4.477-10 10 0 5.524 4.477 10 10 10h16.64c4.231.035 8.25 1.848 11.075 5h-27.715c-5.523 0-10 4.477-10 10 0 5.524 4.477 10 10 10h27.719c-.176 1-.34.414-.528.598a14.824 14.824 0 0 1-10.55 4.402h-16.641c-5.61.094-10.086 4.719-9.988 10.332a10.151 10.151 0 0 0 3.12 7.16l41.579 39.336c3.96 3.844 10.281 3.746 14.125-.21s3.746-10.282-.211-14.126l-.176-.164-24.187-22.855a34.93 34.93 0 0 0 17.074-9.578 32.536 32.536 0 0 0 8.8-14.895h8.008c5.524 0 10-4.476 10-10 0-5.52-4.476-10-10-10h-8.027c-.508-1-1.144-3-1.898-5zm0 0"
                        opacity={1}
                        data-original="#00acea"
                        className=""
                    />
                </g>
            </svg>

        </>
    )
}

export default CostSavingsIcon